import React from 'react'
import ComingSoon from '../components/ComingSoon'

const Cruises = () => {
  return (
    <ComingSoon />
  )
}

export default Cruises